import React, { useState, useEffect } from 'react';
import './HowITwork.css';

// 
import userLogo from '../../assets/img/user-duotone 1.svg';
import truckLogo from '../../assets/img/truck-fast-duotone 1.svg';
import fileImaport from '../../assets/img/file-import-duotone 1.svg';
import languageLogo from '../../assets/img/language-duotone 1.svg';
import CloseIcon from '@mui/icons-material/Close';

import personImage from '../../assets/HJ 1.png'
import settingLogo from '../../assets/img/svgexport-7 (92) 1.svg';


import logo_1 from '../../assets/img/Group.svg'
import logo_2 from '../../assets/img/svgexport-7 (95).svg';
import logo_3 from '../../assets/img/svgexport-7 (96).svg';
import logo_4 from '../../assets/img/svgexport-7 (94).svg'


import arrow from '../../assets/img/dark_arrow.svg'
import uplaodFile from '../../assets/img/uploadFile.svg'
import axios from 'axios';
const HowITwork = () => {
    const API_BASE = "https://api.waraq.co/waraq/api/v1";

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        subject: '',
        message: '',
        attachments: []
    });


    const getAuthHeaders = () => {
        const token = localStorage.getItem("jwtToken");
        return { Authorization: `${token}` };
    };

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [fileName, setFileName] = useState('');

    const validateForm = () => {
        const newErrors = {};

        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email';
        }

        if (!formData.subject.trim()) {
            newErrors.subject = 'Subject is required';
        }

        if (!formData.message.trim()) {
            newErrors.message = 'Message is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            setFormData(prev => ({
                ...prev,
                attachments: [...prev.attachments, ...files]
            }));
        }
    };

    const handleDeleteFile = (indexToRemove) => {
        setFormData(prev => ({
            ...prev,
            attachments: prev.attachments.filter((_, index) => index !== indexToRemove)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        try {
            const submitData = new FormData();
            submitData.append('firstName', formData.firstName);
            submitData.append('lastName', formData.lastName);
            submitData.append('email', formData.email);
            submitData.append('subject', formData.subject);
            submitData.append('message', formData.message);

            if (formData.attachments && formData.attachments.length > 0) {
                formData.attachments.forEach((file) => {
                    submitData.append('attachments', file);
                });
            }
            
            console.log('submitData' , submitData);

            const response = await axios.post(
                `${API_BASE}/email/send`,
                submitData,
                { headers: getAuthHeaders() }
            );

            if (response.status === 200 || response.status === 201) {
                setSuccessMessage('Email sent successfully!');
                setTimeout(() => {
                    setSuccessMessage('');
                }, 3000);

                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    subject: '',
                    message: '',
                    attachments: []
                });
                const fileInput = document.getElementById('file');
                if (fileInput) fileInput.value = '';
            }
        } catch (error) {
            if (error.response) {
                setErrors({ submit: error.response.data.message || 'Failed to send email. Please try again.' });
            } else if (error.request) {
                setErrors({ submit: 'Network error. Please check your connection and try again.' });
            } else {
                setErrors({ submit: 'An error occurred. Please try again.' });
            }
        } finally {
            setIsSubmitting(false);
        }
    };




    return (

        <>


            <main className='main-how-it-works'>

                <div className='waves'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#FFF" fill-opacity="1" d="M0,224L60,202.7C120,181,240,139,360,138.7C480,139,600,181,720,208C840,235,960,245,1080,213.3C1200,181,1320,107,1380,69.3L1440,32L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path></svg>
                </div>

                <div className="container_how_to_works">
                    <h2 className="section-title">How it works</h2>

                    <div className="process-flow">
                        <div className="process-step">
                            <div className="step-icon">
                                <img src={fileImaport} />

                            </div>
                            <h3 className="step-title">File<br />Submission</h3>
                            <p className="step-description">Simply submit your translation requests or documents online, and receive your completed translations directly through our client dashboard.</p>
                            <div className="arrow">

                                <img src={arrow} />
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-icon">

                                <img src={userLogo} />

                            </div>
                            <h3 className="step-title">Assessment &<br />Assignment</h3>
                            <p className="step-description">Waraq Translations assesses the documents to determine the difficulty level, then assigns the files to the translator who is best suited for the job.</p>
                            <div className="arrow">

                                <img src={arrow} />
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-icon">


                                <img src={languageLogo} />
                            </div>
                            <h3 className="step-title">Translation &<br />Proofreading</h3>
                            <p className="step-description">The documents are translated by a professional, native-speaking translator and then carefully reviewed by a proofreader to ensure accuracy.</p>
                            <div className="arrow">

                                <img src={arrow} />
                            </div>
                        </div>

                        <div className="process-step">
                            <div className="step-icon">

                                <img src={truckLogo} />
                            </div>
                            <h3 className="step-title">Formatting &<br />Delivery</h3>
                            <p className="step-description">The documents are then formatted to match the original as closely as possible and, depending on the client's needs, stamped for official use.</p>
                        </div>
                    </div>
                </div>

                <div className="contact-container">
                    <div className="contact-left">

                        <div className="contact-image-wrapper">
                            <span className="circle_1"></span>

                            <div className="contact-image-clip">
                                <img src={personImage} className="contact-image" />
                            </div>

                            <span className="circle_2"></span>
                        </div>



                        <h2>Get easily in touch</h2>
                        <p>We strive to respond to all inquiries as <br /> quickly as possible.</p>
                    </div>

                    <div className="contact-right">
                        <div className="form-card">
                            <div className="form-headerr">
                                <span className="form-icon">
                                    <img src={settingLogo} />
                                </span>
                                <h3>Receive a quote</h3>
                            </div>
                            <form onSubmit={handleSubmit}>

                                <div className="form-row">
                                    <div className="input-wrapper">
                                        <input
                                            name="firstName"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="First Name"
                                        />
                                        {errors.firstName && (
                                            <p className="error-message">{errors.firstName}</p>
                                        )}
                                    </div>

                                    <div className="input-wrapper">
                                        <input
                                            name="lastName"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder="Last Name"
                                        />
                                        {errors.lastName && (
                                            <p className="error-message">{errors.lastName}</p>
                                        )}
                                    </div>
                                </div>


                                <input
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    type="email" placeholder="E-Mail" />
                                {errors.email && (
                                    <p className="error-message">{errors.email}</p>
                                )}

                                <input
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}

                                    type="text" placeholder="Company Name - Subject" />
                                {errors.subject && (
                                    <p className="error-message">{errors.subject}</p>
                                )}

                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Message"></textarea>

                                {errors.message && (
                                    <p className="error-message">{errors.message}</p>
                                )}


                                <div className="file-upload">
                                    <label htmlFor="file">
                                        <img src={uplaodFile} alt='' />
                                        Attach Files
                                    </label>
                                    <input
                                        onChange={handleFileChange}
                                        type="file"
                                        id="file"
                                        hidden
                                        multiple
                                    />
                                </div>


                                <div className='fileUploaded'>
                                    {formData.attachments && formData.attachments.length > 0 && (
                                        <div style={{
                                            marginTop: '10px',
                                        }}>

                                            {formData.attachments.map((file, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    padding: '10px 15px',
                                                    marginBottom: '10px',
                                                    backgroundColor: '#FFFFFF',
                                                    border: '1px solid #E5E7EB',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                                                    maxWidth: '100%', 
                                                    overflow: 'hidden' 
                                                }}>
                                                
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '12px',
                                                        flex: 1,
                                                        minWidth: 0, 
                                                        overflow: 'hidden' 
                                                    }}>
                                                        <div style={{
                                                            width: '40px',
                                                            height: '40px',
                                                            backgroundColor: '#3B82F6',
                                                            borderRadius: '8px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexShrink: 0
                                                        }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                                                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                                <circle cx="8.5" cy="8.5" r="1.5" />
                                                                <polyline points="21 15 16 10 5 21" />
                                                            </svg>
                                                        </div>

                                                        <div style={{
                                                            flex: 1,
                                                            minWidth: 0, 
                                                            overflow: 'hidden' 
                                                        }}>
                                                            <div style={{
                                                                fontSize: '15px',
                                                                fontWeight: '500',
                                                                color: '#111827',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                marginBottom: '4px',
                                                                maxWidth: '100%'
                                                            }}>
                                                                {file.name}
                                                            </div>
                                                            <div style={{
                                                                fontSize: '14px',
                                                                color: '#6B7280'
                                                            }}>
                                                                {(file.size / (1024 * 1024)).toFixed(2)} MB
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <CloseIcon
                                                        onClick={() => handleDeleteFile(index)}
                                                        style={{
                                                            color: '#EF4444',
                                                            cursor: 'pointer',
                                                            flexShrink: 0,
                                                            fontSize: '24px',
                                                            minWidth: '24px'
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>



                                {successMessage && (
                                    <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
                                        {successMessage}
                                    </div>
                                )}

                                {errors.submit && (
                                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                                        {errors.submit}
                                    </div>
                                )}


                                <div className="dialog-actions">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="send-btn" >

                                        {isSubmitting ? 'Sending...' : 'Send'}

                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>


                <section className="section">
                    <div className="section-left">
                        <h2>More Reasons to use<br />Waraq Translations:</h2>
                        <p>
                            Our translation services offer competitive pricing  and flexibility for any document,
                            format and industry-specific translation, with an easy online  process.
                        </p>
                        {/* <button
                             onClick={(e) => {
                                e.preventDefault();
                                window.scrollBy({
                                  top: -650,
                                  behavior: 'smooth',
                                });
                              }}
                        >Order Your Translation</button> */}
                        <button
                            onClick={(e) => {
                                e.preventDefault();

                                let scrollDistance = -650;

                                if (window.innerWidth <= 768) {

                                    scrollDistance = -900;
                                } else if (window.innerWidth <= 1024) {

                                    scrollDistance = -900;
                                }

                                window.scrollBy({
                                    top: scrollDistance,
                                    behavior: 'smooth',
                                });
                            }}
                        >
                            Order Your Translation
                        </button>

                    </div>

                    <div className="section-right">
                        <div className="card">
                            <div className="card-icon">
                                <img src={logo_4} />
                            </div>
                            <h3>QUALITY ASSURANCE</h3>
                            <p>Certified native-speaker translators deliver quality translations through strict quality control measures.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">

                                <img src={logo_3} />
                            </div>
                            <h3>SPEEDY DELIVERY</h3>
                            <p>We understand the importance of timely delivery, so we work efficiently to ensure that translations are delivered on schedule.</p>
                        </div>
                        <div className="card" >
                            <div className="card-icon">

                                <img src={logo_2} />
                            </div>
                            <h3>SECURITY</h3>
                            <p>We understand the importance of confidentiality and take all necessary measures to protect our customers’ information.</p>
                        </div>
                        <div className="card">
                            <div className="card-icon">

                                <img src={logo_1} />
                            </div>
                            <h3>CUSTOMER SUPPORT</h3>
                            <p>Dedicated customer support team available to answer questions, help with issues, and improve your experience.</p>
                        </div>
                    </div>
                </section>


            </main>

        </>



    );
};

export default HowITwork;
